import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=571638a9&scoped=true"
import script from "./backTop.vue?vue&type=script&lang=js"
export * from "./backTop.vue?vue&type=script&lang=js"
import style0 from "./backTop.vue?vue&type=style&index=0&id=571638a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571638a9",
  null
  
)

export default component.exports